'use client'

import { type ReactNode } from 'react'
import { ErrorBoundary } from './ErrorBoundary'
import { FeedbackModal } from './FeedbackModal'
import { ErrorReportModal } from './ErrorReportModal'
import { AccountModal } from './AccountModal'
import { GlobalErrorBanner } from './GlobalErrorBanner'

interface FeedbackProviderProps {
  children: ReactNode
}

export function FeedbackProvider({ children }: FeedbackProviderProps) {
  return (
    <ErrorBoundary>
      {children}
      <GlobalErrorBanner />
      <FeedbackModal />
      <ErrorReportModal />
      <AccountModal />
    </ErrorBoundary>
  )
}
